import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts";
import { LoginRequest } from "@/domains/auth";
// components
import { Button, Form, Input } from "antd";

export const LoginPage = () => {
  const navigate = useNavigate();

  const auth = useAuth();

  const [error, setError] = useState(false);

  const onFinish = async (values: LoginRequest) => {
    try {
      await auth.login(values);
      navigate("/", { replace: true });
    } catch (e) {
      console.log(e);
      setError(true);
    }

    return;
  };

  return (
    <div className="w:100vw h:100vh flex jc:center ai:center bg:#666">
      <div className="w:480 h:300 flex flex:col bg:#eee r:12">
        <h1 className="my:32 t:center">{import.meta.env.VITE_APP_NAME}</h1>

        <div className="flex-1 flex jc:center ai:center">
          <Form
            name="basic"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 18 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            style={{ width: 480 }}
            autoComplete="off"
          >
            <Form.Item label="帳號" name="username">
              <Input onInput={() => setError(false)} />
            </Form.Item>

            <Form.Item label="密碼" name="password">
              <Input.Password onInput={() => setError(false)} />
            </Form.Item>

            {error && (
              <div className="mb:8 t:center fg:red-5">帳號或密碼錯誤</div>
            )}

            <div className="flex jc:center">
              <Button type="primary" htmlType="submit">
                登入
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
